import gqlTagGira from 'graphql-tag';

export const DELETE_JIRA_BUSINESS_CATEGORY = gqlTagGira`
  mutation DeleteJwmCategory($input: JWMDeleteCategoryInput!) {
    deleteJwmCategory(input: $input) {
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
    }
  }
`;
